import React from 'react';
import StackedVerticalBarChart from '../../../../ui/StackedVerticalBarChart';
import useFetchData from '../../../../hooks/useFetchData';
import { getProjectStatistics } from '../../../../apis/impact-report/report';
import Loader from '../../../../ui/Loader';
import { useFilters } from '../../../../contexts/FiltersContext';
import { useSearchParams } from 'react-router-dom';

const stackValues = {'participated':"Activities participated in", 'created':"Activities created", 'validated':"Activities validated"}
const ContributionTab = ({projectId,imageGenerationTimestamp}) => {
    
        const { loading, response, error } = useFetchData(getProjectStatistics,[projectId,"USER_WISE_STATISTICS",imageGenerationTimestamp,""],[projectId,"USER_WISE_STATISTICS",imageGenerationTimestamp,""]);

        const { selectedPrimary } = useFilters();

    const contributionData =  response?.userWiseStatistics?.map(user=>
        {
            return  { 
                name: user?.username
                , 
                participated: user?.bountyAcceptanceCount, 
                created: user?.bountyCreationCount, 
                validated: user?.bountyValidationCount,
                key:user?.uid,
                profileImage:user?.profileImage
            }
        }
        )?.sort((a,b)=>(b?.participated + b?.created + b?.validated) - (a?.participated + a?.created + a?.validated))

    const stackKeys = ['participated', 'created', 'validated'];
    const colors = ['#76C8E8', '#003C73', '#B0EAC0']; // participated, created, validated

    const filters = selectedPrimary || ['All']
    const allLabel = 'All'
    
    const normalized = (contributionData || []).map(row => {
        const isParticipated = filters.includes('Participated') || filters.includes(allLabel)
        const isCreated = filters.includes('Created') || filters.includes(allLabel)
        const isValidated = filters.includes('Validated') || filters.includes(allLabel)
        
        return {
            ...row,
            participated: isParticipated ? row.participated : 0,
            created: isCreated ? row.created : 0,
            validated: isValidated ? row.validated : 0,
        }
    })

    // Calculate dynamic domain and ticks based on filtered data
    const allValues = normalized.flatMap(d => [
        Number(d?.participated ?? 0), 
        Number(d?.created ?? 0), 
        Number(d?.validated ?? 0)
    ]).filter(val => val > 0); // Only consider non-zero values
    
    const maxVal = allValues.length ? Math.max(...allValues, 0) : 0;
    const isSmall = maxVal <= 5;
    const roundedMax = isSmall
        ? Math.max(5, Math.ceil(maxVal / 5) * 5)
        : Math.ceil(maxVal / 10) * 10;
    const step = isSmall ? 1 : Math.max(1, Math.round(roundedMax / 5));
    const computedTicks = [];
    for (let t = 0; t <= roundedMax; t += step) {
        computedTicks.push(t);
    }
    const computedDomain = [0, roundedMax];

    if (loading) return  <div className='w-full h-[23.9375rem] flex pt-11 justify-center '  ><Loader/></div> ;
    
    if(normalized?.length === 0) return <div className="w-full h-[23.9375rem] flex items-center justify-center text-gray-500">No data available</div>; 

    if(!loading && normalized?.length > 0)
    return (
        <StackedVerticalBarChart
            data={normalized}
            stackKeys={stackKeys}
            xAxisLabel="Users"
            yAxisLabel="Contributions"
            colors={colors}
            barSize={40}
            height={500}
            isCustom={true}
customise = {(value)=>
{
    return stackValues[value]
}
}
            visibleBars={17}
            showLegend={true}
        />
    );
};

export default ContributionTab; 